export const TEXT = {
  PARAGRAPH: { id: 'payment.paypal_redirection' },
};
